import React, { useState } from 'react';
import { UserIcon, TrendingUpIcon, ClockIcon, QuoteIcon, ExternalLinkIcon } from 'lucide-react';
export const TestimonialsSection = () => {
  const [activeVideoIndex, setActiveVideoIndex] = useState(0);
  const testimonials = [{
    name: 'John M.',
    role: 'Senior iOS Engineer',
    company: 'PayPal',
    thoughts: 'I wouldn\'t have tried to negotiate an offer from Apple, but the guidance from Michelle helped me confidently negotiate up $10k from the initial offer',
    timeline: '6 Weeks',
    increase: '$340,000+ total comp, negotiated up $10k',
    date: 'March 2026'
  }, {
    name: 'Torre T ',
    role: 'Staff Software Engineer',
    company: 'Microsoft',
    thoughts: 'I was going to wait until my company gives out the annual bonus to wait and see. I\'m glad I didn\'t, or else I would have been stuck in the same place ',
    timeline: '2+ Months',
    increase: '$300,000+ total comp',
    date: 'Feb 2026'
  }, {
    name: 'Michael N',
    role: 'Principal Software Engineer',
    company: 'Blackbird AI, Agileloft',
    thoughts: 'I learned a lot about salary negotiation for a new job. I am used to negotiating when I buy a big item, such as a car, but not much with salary negotiation because I felt the company was in control of the job. But through this process, I learned to negotiate',
    increase: '2 offers, negotiated up $30k',
    date: 'March 2026'
  }, {
    name: 'Craig S',
    role: 'Senior Software Engineer',
    company: 'Kodiak',
    thoughts: '$220K base, 20% annual bonus ($44K), $250K equity over 4 ($62.5K), $10K relocation',
    increase: '$336,500 1st year total comp',
    date: 'March 2026'
  }, {
    name: 'Sasi',
    role: 'Staff Software Engineer',
    company: 'Adelade, Gusto',
    thoughts: 'I was laid off and was job searching on my own for a few months, feeling hopeless after failing rounds around 5 interviews including at Google. ',
    increase: '$100k increase in cash compensation',
    date: 'Feb 2026'
  }, {
    name: 'Michael K.',
    role: 'Senior Frontend Engineer',
    company: 'PayPal',
    thoughts: 'I was skeptical about coaching at first, but the ROI was incredible. The mock interviews and feedback were game-changing.',
    timeline: '2 months',
    increase: '200% compensation increase',
    videoUrl: 'https://youtu.be/m7zGWA8oA-o'
  }, {
    name: 'Habib Q.',
    role: 'Senior Frontend Engineer',
    company: 'Calendly',
    thoughts: 'I went from having to go into the Amazon office 5 days a week, to securing a fully remote role with a stronger compensation.',
    timeline: '3 months',
    increase: '$300,000+ total comp, fully remote'
  }, {
    name: 'Steven',
    role: 'Senior ML Manager',
    company: 'Meta',
    thoughts: 'In 3 months, we were able to double my comp, and negotiated up $150k from the initial offer.',
    timeline: '3 months',
    increase: '$840k total comp from $400k, $150k up from original offer'
  }, {
    name: 'Marcel D.',
    role: 'Senior Software Engineer',
    company: 'Flex, DoorDash, Smartsheet',
    thoughts: 'I walked away with three offers—including one two levels above my previous role. ApplyPass gave me the clarity and tools I needed to finally break through.',
    timeline: '2 months',
    increase: '85% compensation increase',
    videoUrl: 'https://youtu.be/w76PJhl3oqk'
  }, {
    name: 'Mitchell N',
    role: 'Machine Learning Engineer',
    company: '',
    thoughts: 'I got the coaching I needed to break into Machine Learning with 2 years of experience, and with a significant increase in comp.',
    timeline: '5 months',
    increase: '$95K compensation increase'
  }, {
    name: 'John B. L.',
    role: 'Staff Software Engineer',
    company: 'Apple',
    thoughts: "The coaching helped me make a really strong case with the hiring managers - even the recruiters couldn't believe that they approved the offer.",
    timeline: '2 months',
    increase: '$842,000 total Compensation',
    videoUrl: 'https://youtu.be/jH2H71wISW4',
    image: ''
  }, {
    name: 'Joey',
    role: 'Support Engineering Manager',
    company: 'Replit',
    thoughts: 'Working with Michelle helped me switched to a startup leadership role at a fast-growing AI company.',
    timeline: '3 months',
    increase: '2x Total compensation increase - $225k base, $400 TC',
    image: ''
  }, {
    name: 'Tyler',
    role: 'Support Machine Learning Engineer',
    company: 'Lattice',
    timeline: '3 months',
    thoughts: "I have 22+ years of experience, but don't think I could've landed such a big jump from my previous compensation on my own.",
    increase: 'From $170k to $280k base, $504k total comp',
    image: ''
  }, {
    name: 'William',
    role: 'Staff iOS Engineer',
    company: 'Venmo',
    timeline: '4.5 weeks',
    thoughts: "It takes an average of 6-12 months to land a job these days - but not only did David and Michelle help me secure my current offer in 4.5 weeks, I've easily doubled my comp.",
    increase: 'From $180k to $280k, $40k more than original offer',
    image: ''
  }, {
    name: 'Becca',
    role: 'Senior Full Stack Engineer',
    company: 'Gusto',
    timeline: '3 months',
    thoughts: "It takes an average of 6-12 months to land a job these days - but not only did David and Michelle help me secure my current offer in 4.5 weeks, I've easily doubled my comp.",
    increase: 'From $165,000 to $303,000',
    image: ''
  }, {
    name: 'Julissa C.',
    role: 'Senior Software Engineer in AI',
    company: 'Polly',
    thoughts: 'ApplyPass and the coaching team got me into the AI space without taking a pay cut. Unreal.',
    timeline: '1 month',
    increase: 'Pivoted without a paycut'
  }];
  return <section className="w-full bg-[#231232] py-24" id="testimonials" data-id="element-220">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-221">
        <div className="text-center mb-16" data-id="element-222">
          <span className="inline-block px-4 py-1.5 bg-[#FFC501]/10 text-[#FFC501] rounded-full text-sm font-medium mb-4" data-id="element-223">
            PROVEN RESULTS
          </span>
          <h2 className="text-4xl sm:text-5xl font-outfit font-bold mb-6 text-white" data-id="element-224">
            Success Stories
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-[#FFC501] to-[#DF4425] mx-auto rounded-full mb-6" data-id="element-225"></div>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-226">
            Real results from engineers who've transformed their careers
          </p>
        </div>
        {/* Results Dashboard */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-227">
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 text-center hover-card" data-id="element-228">
            <TrendingUpIcon size={32} className="text-[#FFC501] mb-4 mx-auto" data-id="element-229" />
            <h3 className="text-2xl font-outfit font-bold mb-2 text-white" data-id="element-230">
              127%
            </h3>
            <p className="text-gray-300" data-id="element-231">Average compensation increase</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 text-center hover-card" data-id="element-232">
            <UserIcon size={32} className="text-[#FFC501] mb-4 mx-auto" data-id="element-233" />
            <h3 className="text-2xl font-outfit font-bold mb-2 text-white" data-id="element-234">
              100%
            </h3>
            <p className="text-gray-300" data-id="element-235">Success rate in getting offers</p>
          </div>
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 text-center hover-card" data-id="element-236">
            <ClockIcon size={32} className="text-[#FFC501] mb-4 mx-auto" data-id="element-237" />
            <h3 className="text-2xl font-outfit font-bold mb-2 text-white" data-id="element-238">
              3-4 Months
            </h3>
            <p className="text-gray-300" data-id="element-239">Average time to first offer</p>
          </div>
        </div>
        {/* Case Studies */}
        <div className="grid md:grid-cols-2 gap-8" data-id="element-240">
          {testimonials.map(testimonial => <div key={testimonial.name} className="relative backdrop-blur-xl bg-white/5 rounded-xl p-8 border border-white/10 hover-card" data-id="element-241">
               {/* Date Bar */}
              {testimonial.date && <div className="mb-6 pb-4 flex items-center justify-between gap-4 relative z-10" data-id="element-242">
                  <div className="text-white/40 text-xs" data-id="element-243">
                    {testimonial.date && <span data-id="element-244">Offer received: {testimonial.date}</span>}
                  </div>
                  
                </div>}
              <div className="flex items-center gap-4 mb-6" data-id="element-245">
                {testimonial.image ? <img src={testimonial.image} alt={testimonial.name} className="w-16 h-16 rounded-full object-cover border-2 border-white/20" data-id="element-246" /> : <div className="w-16 h-16 rounded-full border-2 border-white/20 bg-white/5 flex items-center justify-center" data-id="element-247">
                    <UserIcon size={32} className="text-white/40" data-id="element-248" />
                  </div>}
                <div data-id="element-249">
                  <h4 className="font-outfit font-bold text-xl text-white" data-id="element-250">
                    {testimonial.name}
                  </h4>
                  <p className="text-white/60" data-id="element-251">
                    {testimonial.role} at {testimonial.company}
                  </p>
                </div>
              </div>
              <div className="space-y-4" data-id="element-252">
                <div data-id="element-253">
                  <h5 className="text-sm font-medium uppercase tracking-wider text-white/40 mb-2" data-id="element-254">
                    The Experience
                  </h5>
                  <p className="text-white/80 text-lg" data-id="element-255">
                    {testimonial.thoughts}
                  </p>
                </div>
                <div data-id="element-256">
                  <h5 className="text-sm font-medium uppercase tracking-wider text-white/40 mb-2" data-id="element-257">
                    Timeline to Offer
                  </h5>
                  <p className="text-white/80 font-medium" data-id="element-258">
                    {testimonial.timeline}
                  </p>
                </div>
                <div className="relative" data-id="element-259">
                  <div className="absolute inset-0 bg-gradient-to-r from-[#FFC501]/10 to-[#6805DA]/10 rounded-lg blur" data-id="element-260" />
                  <div className="relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-4" data-id="element-261">
                    <h5 className="text-sm font-medium uppercase tracking-wider text-white/40 mb-2" data-id="element-262">
                      The Result
                    </h5>
                    <p className="text-white font-bold text-xl bg-gradient-to-r from-[#FFFCE7] to-[#FFC501] bg-clip-text text-transparent" data-id="element-263">
                      {testimonial.increase}
                    </p>
                  </div>
                </div>
              </div>

             {/* Video Bar */}
              {testimonial.videoUrl && <div className="mt-6 pt-4 border-t border-white/10 flex items-center justify-between gap-4 relative z-10" data-id="element-264">
                
                  {testimonial.videoUrl && <a href={testimonial.videoUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 border border-[#FFC501]/30 text-[#FFC501] rounded-full px-4 py-1.5 text-sm hover:brightness-110 transition-all ml-auto" data-id="element-265">
                      Watch Video Testimonial <ExternalLinkIcon size={14} data-id="element-266" />
                    </a>}
                  
                </div>}
              

              {/* Subtle corner gradient */}
              <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-r from-[#6805DA]/5 to-transparent rounded-br-xl pointer-events-none" data-id="element-267" />
            </div>)}
        </div>
      </div>
    </section>;
};